import { Tab, Tabs } from '@patternfly/react-core'
import * as React from 'react'
import { useState, useCallback } from 'react'

import { RequireFeatureFlag } from '@app/components/feature_flags/require-feature-flag'
import PageLayout from '@app/components/page_layout'
import { useFeatureFlags } from '@app/domain/feature-flags/feature-flags.hooks'
import { FeatureFlagId } from '@app/domain/feature-flags/feature-flags.interface'
import { TabContent } from '@app/utils/styles/tab-content'

import DomainEventsScreen from './domain_events'
import FeatureFlagScreen from './feature_flags'
import { ProgramConfigurationScreen } from './program_configuration'

enum EventKeys {
  ProgramConfiguration,
  FeatureFlags,
  DomainEvents,
}

const AdminScreen = function () {
  const { isFeatureFlagEnabled } = useFeatureFlags()

  const getDefaultKey = useCallback(() => {
    if (!isFeatureFlagEnabled(FeatureFlagId.ProgramConfiguration)) {
      return EventKeys.FeatureFlags
    } else {
      return EventKeys.ProgramConfiguration
    }
  }, [isFeatureFlagEnabled])

  const [activeKey, setActiveKey] = useState(getDefaultKey())

  const handleTabClick = useCallback((event, tabIndex) => {
    setActiveKey(tabIndex)
  }, [])

  return (
    <PageLayout>
      <div>
        <Tabs mountOnEnter activeKey={activeKey} onSelect={handleTabClick}>
          <RequireFeatureFlag
            key="program_configuration_enabled"
            feature={FeatureFlagId.ProgramConfiguration}
          >
            <Tab
              key={EventKeys.ProgramConfiguration}
              eventKey={EventKeys.ProgramConfiguration}
              title="Program Configuration"
            />
          </RequireFeatureFlag>
          <Tab
            key={EventKeys.FeatureFlags}
            eventKey={EventKeys.FeatureFlags}
            title="Feature Flags"
          />
          <Tab
            key={EventKeys.DomainEvents}
            eventKey={EventKeys.DomainEvents}
            title="Domain Events"
          />
        </Tabs>
        <TabContent>
          {activeKey === EventKeys.ProgramConfiguration ? (
            <ProgramConfigurationScreen />
          ) : null}
          {activeKey === EventKeys.FeatureFlags ? <FeatureFlagScreen /> : null}
          {activeKey === EventKeys.DomainEvents ? <DomainEventsScreen /> : null}
        </TabContent>
      </div>
    </PageLayout>
  )
}

export default AdminScreen
